import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import LocationSelector from '../../../LocationSelector';
import LoginHeader from '../../../Login_header';
import Menu from '../../../Menu';
import * as Picklist from "../../../Picklist";
import * as Common from './../../../Common';
import Dialog from './../../../Dialog';
const Rep_profitability_transaction = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const processStatus = sessionStorage.getItem('process');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');
    const [GenerateType, setGenerateType] = useState("V");
    const [vtmFromDate, setVtmFromDate] = useState(new Date());
    const [vtmToDate, setVtmToDate] = useState(new Date());
    const [hdrSrno, setHdrSrno] = useState("");
    const [reportType, setReportType] = useState("D");
    const [filtercurrency, setFilterCurrency] = useState(true);
    const [filterVtm, setFilterVtm] = useState(true);
    const [filterEvtm, setFilterEvtm] = useState(true);
    const [filterDD, setFilterDD] = useState(true);
    const [filterTT, setFilterTT] = useState(true);
    const [nParty, setNParty] = useState(null);
    const [filterTransactionType, setFilterTransactionType] = useState("A");
    const [nAgent, setNAgent] = useState(null);
    const [nExecutive, setNExecutive] = useState(null);
    const [filterParty, setFilterParty] = useState("A");
    const [filterAgent, setFilterAgent] = useState("A");
    const [filterExecutive, setFilterExecutive] = useState("A");

    const [locationCode, setLocationCode] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState('A');

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_PROFITABILITY_TRANSACTION'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleGenerate = () => {
        $(".loader").show();
        if (!Common.validateFinYear(Common.dateYMD(vtmFromDate), Common.dateYMD(vtmToDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        } else if (vtmFromDate > vtmToDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        var msg = [], i = 0;
        if ((radioType === 'O' && locationCode === '0') || (radioType == 'S' && selectedItems.length === 0) ||
            ((!filtercurrency) && (!filterDD) && (!filterEvtm) && (!filterTT) && (!filterVtm)) ||
            (filterParty === 'O' && nParty === null) || (filterAgent === 'O' && nAgent === null) || (filterExecutive === 'O' && nExecutive === null)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((radioType == 'O' && locationCode == '0') ? "Please select location." : '');
            msg[i++] = ((radioType == 'S' && selectedItems.length === 0) ? "Please select atleast one location." : '');
            msg[i++] = (((!filtercurrency) && (!filterDD) && (!filterEvtm) && (!filterTT) && (!filterVtm)) ? "Please check atleast one checkbox  ." : '');
            msg[i++] = (((filterParty === 'O' && nParty === null)) ? "Please select party." : '');
            msg[i++] = (((filterAgent === 'O' && nAgent === null)) ? "Please select Agent." : '');
            msg[i++] = ((filterExecutive === 'O' && nExecutive === null) ? "Please select executive." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            let fromDate = new Date(vtmFromDate);
            let toDate = new Date(vtmToDate);
            const obj = {
                fromDate: new Date(new Date(vtmFromDate).setDate(new Date(vtmFromDate).getDate() - 1)).toISOString().split("T")[0],
                toDate: new Date(new Date(vtmToDate).setDate(new Date(vtmToDate).getDate() - 1)).toISOString().split("T")[0],
                filterBalanceBookType: 'P',
                showHeader: false,
                filterLocationType: radioType,
                radioTypeLocation: radioType,
                location: locationCode,
                multipleLocation: selectedItems,
            }
            Common.callApi(Common.apiRepProfitabilityTransaction, [sid, "insertactivitylog", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                setHdrSrno(resp.srno);
                processDate(fromDate, toDate.setDate(toDate.getDate() + 1), resp.srno);
            })
        }
    }
    function processDate(fromDate, toDate, srno) {
        console.log("this is start")
        console.log("thsi is from date", fromDate, "this is todate", toDate)
        if (fromDate > toDate) {
            // $(".loader").hide();
            updateStockValuation(srno);
            return;
        }
        setMsgText("Processing data for date  ... " + Common.dateDMY(fromDate));
        setMsgBox(true);
        const obj = {
            srno: srno,
            fromDate: Common.dateYMD(fromDate),
            fromDateDMY: Common.dateDMY(vtmFromDate),
            toDate: Common.dateYMD(vtmToDate),
            toDateDMY: Common.dateDMY(vtmToDate),
            generateType: GenerateType,
            locationCode: locationCode,
            locationType: radioType,
            filterLocationType: radioType,
            radioTypeLocation: radioType,
            location: locationCode,
            multipleLocation: selectedItems,
            filterCN: filtercurrency,
        };
        Common.callApi(Common.apiRepProfitabilityTransaction, [sid, "insertprofitability", JSON.stringify(obj)], result => {
            console.log("this is end")
            fromDate.setDate(fromDate.getDate() + 1);
            processDate(fromDate, toDate, srno);
        });
    }
    const updateStockValuation = (srno) => {
        Common.callApi(Common.apiRepProfitabilityTransaction, [sid, "updatestockvaluation", srno], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "1") {
                setMsgText("Data generated for all date successfully.");
                setMsgBox(true);
                GenerateDetailedProductHeaderWiseData(srno);
            } else {

            }
        });
    }
    const GenerateDetailedProductHeaderWiseData = (srno) => {
        setMsgText("Generating Report.");
        setMsgBox(true);
        const obj = {
            srno: srno,
            fromDate: Common.dateYMD(vtmFromDate),
            fromDateDMY: Common.dateDMY(vtmFromDate),
            toDate: Common.dateYMD(vtmToDate),
            toDateDMY: Common.dateDMY(vtmToDate),
            generateType: GenerateType,
            locationType: radioType,
            filterLocationType: radioType,
            radioTypeLocation: radioType,
            locationCode: locationCode,
            multipleLocation: selectedItems,
            reportType: reportType,
            filterCN: filtercurrency,
            filterDD: filterDD,
            filterEvtm: filterEvtm,
            filterTT: filterTT,
            filterVtm: filterVtm,
            filterTransactionType: filterTransactionType,
            filterParty: filterParty,
            nParty: nParty,
            nExecutive: nExecutive,
            filterAgent: filterAgent,
            nAgent: nAgent,
            filterExecutive: filterExecutive
        };
        if (GenerateType === 'D') {
            Common.callDownloadApiPost1(Common.apiRepProfitabilityTransaction, "post", [sid, "download", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setMsgText(Common.buildMessageFromArray([result]));
                setMsgBox(true);
            });
        } else {
            Common.callApi(Common.apiRepProfitabilityTransaction, [sid, "view", JSON.stringify(obj)], result => {
                setMsgText("Report Generated Successfully.");
                setMsgBox(true);
                var newWindow = window.open();
                newWindow.document.write(result);
                $(".loader").hide();
            });

        }
    }

    const handlePartyChange = (value) => {
        setNParty(value);
        console.log("this is party", value)
        var id = value.id;
        var location = id.split("^");
    }
    const handleAgentChange = (value) => {
        setNAgent(value);
    }
    const handleExecutiveChange = (value) => {
        setNExecutive(value);
    }
    const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
        setLocationCode(newLocationCode);
        setSelectedItems(newSelectedItems);
        setRadioType(newRadioType);
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Report Profitability</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-6 col-6'>
                        <Form.Label>Location Filter</Form.Label><br />
                        <LocationSelector onDataFromChild={handleDataFromChild} />
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Transaction Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterTransactionType} onChange={e => setFilterTransactionType(e.target.value)}
                                required>
                                <option value="A">All</option>
                                <option value="SP">SP</option>
                                <option value="SB">SB</option>
                                <option value="A">VR</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label> From Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={vtmFromDate}
                                onChange={(date) => setVtmFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label> To Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={vtmToDate}
                                onChange={(date) => setVtmToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Party Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterParty} onChange={(e) => setFilterParty(e.target.value)}
                                required>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterParty === 'O' ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Party<span className='colorThemeRed'>*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={nParty}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'CORPORATE  , DEALER , ISSUER', locationCode)}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handlePartyChange}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                        : null}
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Executive Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterExecutive} onChange={(e) => setFilterExecutive(e.target.value)}
                                required>
                                <option value="A">All</option>
                                <option value="O">One</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterExecutive === 'O' ?
                        < Col className="col-md-3 col-6">
                            <Form.Group>
                                <Form.Label>Executive</Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={nExecutive}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchExecutivePicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleExecutiveChange}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                        : null}
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Agent Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterAgent} onChange={(e) => setFilterAgent(e.target.value)}
                                required>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterAgent === 'O' ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Agent<span className='colorThemeRed'>*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={nAgent}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT', locationCode)}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleAgentChange}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                        : null}
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Report Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={reportType} onChange={e => setReportType(e.target.value)}
                                required>
                                <option value="D">Product Wise</option>
                                <option value="H">Invoice Wise</option>
                                <option value="E">Executive Wise</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={GenerateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="Currency "
                            checked={filtercurrency}
                            onChange={() => setFilterCurrency(!filtercurrency)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="VTM "
                            checked={filterVtm}
                            onChange={() => setFilterVtm(!filterVtm)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="EVTM "
                            checked={filterEvtm}
                            onChange={() => setFilterEvtm(!filterEvtm)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="DD "
                            checked={filterDD}
                            onChange={() => setFilterDD(!filterDD)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="TT"
                            checked={filterTT}
                            onChange={() => setFilterTT(!filterTT)}
                        />
                    </Col>
                </Row >
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

            </Container >
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_profitability_transaction;